<script module lang="ts">
	export interface I18NStrings {
		username: string
		password: string
		login: string
		username_required: string
		password_required: string
	}
</script>

<script lang="ts">
	import BaseInput from './BaseInput/BaseInput.svelte'
	import Button from './Button.svelte'
	import { ButtonType } from './Button.svelte'
	import type { Credentials } from '../models/credentials'

	interface Props {
		i18NStrings?: I18NStrings
		onLoginClicked?: ((data: Credentials) => void) | null
	}

	let {
		i18NStrings = {
			username: 'Username',
			password: 'Password',
			login: 'Login',
			username_required: 'Username is required',
			password_required: 'Password is required'
		},
		onLoginClicked = null
	}: Props = $props()

	let username: string = $state('')
	let password: string = $state('')
	let errors: Record<string, string> = $state({})
	let touchedFields: Record<string, boolean> = $state({
		username: false,
		password: false
	})

	const validate = (): Record<string, string> => {
		const errors: Record<string, string> = {}
		if (touchedFields.username && username === '') {
			errors.username = i18NStrings.username_required
		}
		if (touchedFields.password && password === '') {
			errors.password = i18NStrings.password_required
		}
		return errors
	}

	const validateAndSubmit = () => {
		touchedFields = { username: true, password: true }
		errors = validate()
		if (!Object.keys(errors).length) {
			onLoginClicked?.({ username, password })
		}
	}

	$effect(() => {
		errors = validate()
	})
</script>

<div class="login-form">
	<fieldset class="fieldset">
		<legend>{i18NStrings.login}</legend>
		<BaseInput
			size="md"
			type="text"
			label={i18NStrings.username}
			errorMessage={errors.username}
			showError={!!errors.username}
			value={username}
			onInput={(v) => (username = v)}
			onBlur={() => (touchedFields.username = true)}
		/>
		<BaseInput
			size="md"
			type="password"
			label={i18NStrings.password}
			errorMessage={errors.password}
			showError={!!errors.password}
			value={password}
			onInput={(v) => (password = v)}
			onBlur={() => (touchedFields.password = true)}
		/>

		<Button
			onclick={validateAndSubmit}
			buttonText={i18NStrings.login}
			buttonType={ButtonType.BRAND}
		/>
	</fieldset>
</div>

<style>
	.login-form {
		@apply flex justify-center items-center h-screen;
	}

	.fieldset {
		@apply border border-black rounded-md p-6;
	}

	.fieldset > * {
		@apply block;
	}

	.fieldset > :global(:not(legend) + *) {
		@apply mt-4;
	}
</style>
